import { BadgeCheck } from "lucide-react";
import { useLang } from "@/context/LangContext";
import { cn } from "@/lib/utils";

/** ✔ Fournisseur vérifié — shown only when `verified_pro` is true. */
export function VerifiedProBadge({ className = "", size = "sm" }) {
  const { t } = useLang();
  const textClass = size === "xs" ? "text-[10px] px-1.5 py-0.5" : "text-[11px] px-2 py-0.5";
  const iconClass = size === "xs" ? "h-3 w-3" : "h-3.5 w-3.5";

  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-full bg-emerald-700 font-bold uppercase tracking-wide text-white shadow-sm",
        textClass,
        className,
      )}
    >
      <BadgeCheck className={iconClass} aria-hidden />
      {t("badge.verified_supplier")}
    </span>
  );
}
